import { Page } from '@/utils';

export default defineNuxtRouteMiddleware(async () => {
  const auth = useAuthStore();
  const localePath = useLocalePath()

  const token = useCookie('authorization');
  if (token.value || auth.token) return localePath({ name: Page.CATALOG });
});
